import faker from 'faker';

import { randomHtmlText, withSeo, VersionedFactory } from './utils';

const content = {
  title: (i) => `${i} ${faker.lorem.sentence()}`,
  text: () => randomHtmlText(),
  ...withSeo(),
};

export default {
  book: VersionedFactory.extend({
    draft: {
      en: content,
      fr: content,
    },
  }),
};
